import { queryOptions } from "react-query";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@/react/lib/queries/createQueryKeyFactory";
import type {
  MasqueradingEntity,
  MasqueradingMode,
} from "@/react/types/Masquerading";

interface EntityResponse {
  category: string | null;
  query: string | null;
  records: MasqueradingEntity[];
}

const masqueradingEntityKey = createQueryKeyFactory("masquerading-entity");

export const masqueradingEntityQueries = {
  list: ({
    communityId,
    currentEntityKey,
    mode,
    query,
  }: {
    communityId: number;
    currentEntityKey: string;
    mode: MasqueradingMode;
    query: string;
  }) =>
    queryOptions({
      queryKey: masqueradingEntityKey.key(
        communityId,
        currentEntityKey,
        mode,
        query,
      ),
      queryFn: () =>
        reactQueryGet<EntityResponse>(
          internalApi.masquerading.entities.index({
            browse: !query,
            members_only: mode === "edit",
            query,
          }),
        ),
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    }),
};
